import React from 'react';
import { Tooltip } from '../../Tooltip';
import { Input } from '../../Input';
import { defaultDateFormat, toDateFormat } from '../../../utilities/dateFormat';
import InputMask from 'react-input-mask';
import { DateTime } from 'luxon';
import { useMergedRef } from '../../../hooks';
export const DateRangeInput = React.forwardRef(({ value, placeholder, onBlur, onChange, error, autoFocus, onFocus, onKeyPress, dateFormat, }, ref) => {
    const [dateValue, setDateValue] = React.useState(value
        ? DateTime.isDateTime(value)
            ? toDateFormat.numeric(value, dateFormat)
            : toDateFormat.numeric(DateTime.fromFormat(value, dateFormat !== null && dateFormat !== void 0 ? dateFormat : defaultDateFormat), dateFormat)
        : '');
    const [IError, setIError] = React.useState(error);
    const localRef = React.useRef(null);
    const InputRef = useMergedRef(ref, localRef);
    React.useEffect(() => {
        setIError(error);
    }, [error]);
    React.useEffect(() => {
        let stringVal = '';
        if (value) {
            if (DateTime.isDateTime(value)) {
                stringVal = toDateFormat.numeric(value, dateFormat);
            }
            else {
                stringVal = toDateFormat.numeric(DateTime.fromFormat(value, dateFormat !== null && dateFormat !== void 0 ? dateFormat : defaultDateFormat), dateFormat);
            }
        }
        setDateValue(stringVal);
    }, [dateFormat, value]);
    const handleOnChange = (e) => {
        setDateValue(e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e, e.target.value);
    };
    const handleOnBlur = (e) => {
        const currentAsDate = DateTime.fromFormat(e.target.value, dateFormat !== null && dateFormat !== void 0 ? dateFormat : defaultDateFormat);
        if (currentAsDate.isValid) {
            setDateValue(toDateFormat.numeric(currentAsDate, dateFormat));
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e, currentAsDate.toJSDate());
        }
        else {
            setDateValue('');
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e, null);
        }
    };
    const selectAllText = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        e.target.select();
    };
    const mask = (dateFormat !== null && dateFormat !== void 0 ? dateFormat : defaultDateFormat).replace(/[MmDdYyo]/g, '9');
    return (React.createElement(Tooltip, { open: IError, text: IError, direction: "b", className: "flex-grow-1", el: "div" },
        React.createElement(InputMask, { mask: mask, value: dateValue, onFocus: selectAllText, onChange: handleOnChange, onBlur: handleOnBlur }, (() => (React.createElement(Input, { onKeyPress: onKeyPress, error: IError, value: dateValue, icon: "event", iconPosition: "left", fluid: true, className: "m-0 DateRangePicker__input", autoFocus: autoFocus, inputRef: InputRef, placeholder: placeholder }))))));
});
//# sourceMappingURL=DateRangeInput.js.map